import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {Loner} from "../../Loner";
import {LonerSound} from "../../sound/LonerSound";
import {BigWinLevel, LonerWinConfigs} from "../../configs/LonerWinConfigs";
import {LonerGameMode} from "../../server/LonerGameMode";

/**
 * Created by Jerker Nord on 2022-11-09.
 */

export class LonerBigWinPresentation implements SimplePresentation {

    private _controller:SimplePresentationRunnerController;
    private _startBigWin:boolean = false;
    private _initialWinDone:boolean = false;

    public shouldRun():boolean {
        if(Loner.model.winRatio >= 15 && Loner.model.brokeBank == false
            && (Loner.model.data.mode == LonerGameMode.NORMAL && !Loner.isWinBelowStake() && !Loner.isWinBelowPlayedBetValue())) {
            return true;
        } else {
            Loner.idleNormal.bigWinDone = true;
            return false;
        }
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;
        this._startBigWin = true;
        this.checkToStart();
    }

    private checkToStart():void {
        if(this._startBigWin == true && this._initialWinDone == true) {
            this._startBigWin = false;
            this._initialWinDone = false;
            const nonAbortableTL:gsap.core.Timeline = gsap.timeline({onComplete : () => this.triggerMainTL()});
            nonAbortableTL.add(() => {
                Loner.soundPlayer.fadeMusic(1, 0, 400);
                Loner.soundPlayer.playNonLoopSound(LonerSound.BIG_WIN_START);
            });
            nonAbortableTL.add(gsap.timeline({delay : 0.8}));
            nonAbortableTL.add(() => {
                Loner.logoView.hide();
                Loner.xBetView.pauseRedDotBlinkTL();
            });
            nonAbortableTL.add(Loner.bigWinView.getPreBigWinTL());
            nonAbortableTL.add(Loner.bigWinView.show());
        }
    }

    private triggerMainTL():void {
        const levels:BigWinLevel[] = LonerWinConfigs.getBigWinLevels(Loner.model.winRatio);
        const tl:gsap.core.Timeline = gsap.timeline({onComplete : () => this._controller.finish()});
        let levelAborted = false;

        Loner.bigWinView.precalculateScale(Loner.model.winRatio * Loner.model.gameData.playedBetValue);

        for(let level of levels) {
            tl.add(() => {
                levelAborted = false;
            });
            tl.add(() => this._controller.setSkipCallback(() => {
                if(Loner.soundPlayer.player.fetchSoundPlayer(LonerSound.BIG_WIN_START)?.isPlaying){
                    Loner.soundPlayer.stopSound(LonerSound.BIG_WIN_START);
                }
                levelAborted = true;
                tl.seek(level.name + "_end", false);
            }));

            tl.add(Loner.bigWinView.getLevelAnimation(level.from * Loner.model.gameData.playedBetValue, level.to * Loner.model.gameData.playedBetValue, level.duration, level.id));
            tl.addLabel(level.name + "_end");
            tl.add(() => this._controller.setSkipCallback());
            tl.add(() => {
                if(levelAborted) {
                    Loner.soundPlayer.stopSound(LonerSound.BIG_WIN_MUSICS[level.id - 1]);
                }
            });
        }

        tl.add([
            () => {
                Loner.soundPlayer.playSound(LonerSound.BIG_WIN_MUSIC_END);
            },
            () => Loner.soundPlayer.fadeMusic(0, 1, 1250)
        ]);

        tl.add(() => Loner.keypadPlugin.setWin(Loner.model.accumulatedRoundWin, false, Loner.isWinBelowStake()));
        tl.add(Loner.bigWinView.showEnd());
        tl.add(() => {Loner.logoView.show()}, "-=0.6");
        tl.add(Loner.bigWinView.hide());
        if(this.isWinBeforeFeature() == true) {
            tl.add(() => {
                Loner.initialWinView.resetWinContainers();
            });
        }
        tl.add(() => {
            Loner.idleNormal.bigWinDone = true;
        });
    }

    private isWinBeforeFeature():boolean {
        if(Loner.model.mode == LonerGameMode.NORMAL && (Loner.model.nextMode == LonerGameMode.FEATURE_PIN_THE_WIN
            || Loner.model.nextMode == LonerGameMode.FEATURE_TICK_TICK_BOOM || Loner.model.nextMode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK)) {
            return true;
        }
        return false;
    }

    set initialWinDone(value:boolean) {
        this._initialWinDone = value;
        this.checkToStart();
    }
}